import { __extends } from 'tslib';
import * as React from 'react';
import { UitkImage, UitkQueuedImage, UitkFigure, UitkImageLink } from 'uitk-react-images';
import { classNames } from 'uitk-react-utils';
import { isYoutubeSource, UitkVideo } from 'uitk-react-video';
import styles from './uitk-gallery-carousel.css';

var getClassNameList = classNames.bind(styles);
var UitkGalleryCarouselItem = /** @class */ (function (_super) {
    __extends(UitkGalleryCarouselItem, _super);
    function UitkGalleryCarouselItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkGalleryCarouselItem.prototype.render = function () {
        var _a = this.props, ariaHidden = _a.ariaHidden, className = _a.className, alt = _a.alt, src = _a.src, ratio = _a.ratio, enablePreload = _a.enablePreload, onClick = _a.onClick, videoAnalytics = _a.videoAnalytics, videoButtonText = _a.videoButtonText, placeholderImage = _a.placeholderImage, triggerA11yText = _a.triggerA11yText;
        var cssClassNames = getClassNameList("uitk-gallery-carousel-item", className);
        var wrappedClassName = getClassNameList(className);
        var renderedElement;
        if (wrappedClassName && wrappedClassName.includes('uitk-gallery-carousel-item-current')) {
            renderedElement = isYoutubeSource(src) ? (React.createElement(UitkVideo, { alt: alt, analytics: videoAnalytics, src: src, buttonText: videoButtonText })) : (React.createElement(UitkImage, { alt: alt, src: enablePreload ? src : '', placeholderImage: placeholderImage }));
        }
        else {
            renderedElement = React.createElement(UitkQueuedImage, { alt: alt, src: enablePreload ? src : '' });
        }
        return (React.createElement("div", { className: cssClassNames, "aria-hidden": ariaHidden },
            React.createElement(UitkFigure, { imageFit: "cover", ratio: ratio },
                renderedElement,
                onClick && !isYoutubeSource(src) && (React.createElement(UitkImageLink, null,
                    React.createElement("button", { type: "button", onClick: onClick, "data-testid": "uitk-gallery-item-current-trigger", "aria-label": triggerA11yText }, alt))))));
    };
    UitkGalleryCarouselItem.displayName = 'UitkGalleryCarouselItem';
    UitkGalleryCarouselItem.defaultProps = {
        ariaHidden: false
    };
    return UitkGalleryCarouselItem;
}(React.PureComponent));

export { UitkGalleryCarouselItem };
